// Versão do jogo (Godot) que o site oferece para descarregar. Fonte: game-release.json, copiado do
// manifest.json que o ecliptica-tcg gera em cada versão (tools/build_release.ps1; docs/RELEASE.md).
// Os binários NÃO vão para o git: vivem no servidor, em GAME_DOWNLOADS_DIR, e servem-se em /game/<ficheiro>
// (apps/backend/src/static.ts), só com a parte "game" do site ligada. Sem dependências: browser e backend.
import release from "./game-release.json" with { type: "json" };

export type GamePlatform = "windows" | "macos";
export type GameFile = { platform: GamePlatform; file: string; size: number; sha256: string };
export type GameRelease = { version: string; date: string; godot: string; files: GameFile[] };

export const GAME_RELEASE = release as GameRelease;

/** Prefixo dos endereços dos ficheiros do jogo. */
export const GAME_FILES_PREFIX = "/game/";

/** Só nomes simples (sem pastas nem "..") — o backend recusa o resto. */
const GAME_FILE_RE = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

export const gameFileUrl = (file: string) => GAME_FILES_PREFIX + file;

/** Nome do ficheiro pedido em /game/<nome>, ou null se o endereço não for um ficheiro do jogo válido. */
export function gameFileName(path: string): string | null {
  if (!path.startsWith(GAME_FILES_PREFIX)) return null;
  const name = path.slice(GAME_FILES_PREFIX.length);
  return GAME_FILE_RE.test(name) && !name.includes("..") ? name : null;
}
